import { colors } from "colors"
import { Platform, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  bottomContainer: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    height: "100%",
    top: -20,
    width: "100%",
  },
  bottomContentContainer: { flex: 1, margin: 10 },
  button: {
    marginTop: 30,
  },
  buttonContainer: { borderRadius: 20 },
  buttonText: { fontSize: 18 },
  container: {
    borderRadius: 20,
    height: "100%",

    zIndex: 99,
  },
  dropdown: {
    backgroundColor: colors.inputFieldBackground,
    borderColor: colors.inputFieldBorder,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 6,
    marginTop: 10,
    minHeight: 50,
    paddingRight: 10,
  },
  errorTextField: {
    borderColor: colors.error,
  },
  fieldTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 6,
    marginTop: 10,
    paddingLeft: 4,
  },
  idContainer: { flexDirection: "row", justifyContent: "space-between", zIndex: 10000, flex: 1 },
  idNoContainer: { flex: 1, marginLeft: 10 },
  idTypeContainer: { flex: 1 },
  inputContainer: { alignSelf: "center", marginTop: 10 },
  inputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  modalContainer: { justifyContent: "flex-end", margin: 0, padding: 0 },
  modalContentButton: { borderBottomWidth: 0.3, padding: 20 },
  modalContentContainer: { backgroundColor: colors.white, maxWidth: 800, alignSelf: "center" },
  overHeadButton: {
    alignItems: "center",
    backgroundColor: colors.lighterGrey,
    borderRadius: 999,
    flex: 1,
    justifyContent: "center",
  },
  overHeadContainer: {
    alignSelf: "center",
    borderColor: colors.white,
    borderRadius: 999,
    borderWidth: 8,
    height: 100,
    position: "absolute",
    top: -50,
    width: 100,
    zIndex: 999,
  },
  profilePictureImage: { borderRadius: 999, flex: 1, height: "100%", width: "100%" },
  scrollView: { marginTop: 50 },
  scrollViewContentContainer: { flexGrow: 1, paddingBottom: Platform.OS === "web" ? 220 : 400 },
  stickyBottomContainer: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    bottom: 0,

    elevation: 1,
    justifyContent: "center",
    paddingBottom: 15,
    padding: 10,
    position: "absolute",
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    width: "100%",
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    marginBottom: 6,
    paddingLeft: 4,
  },
  titleContainer: {
    backgroundColor: colors.white,
    left: 20,
    opacity: 1,
    position: "absolute",
    top: 2,
    zIndex: 9999,
  },
})
